import { useCallback, useEffect, useState } from "react";
import useComposerSaved from "./useComposerSaved";

const useCareCaptureDate = (childId) => {
  const [captureDate, setCaptureDate] = useState(() => new Date());
  const [captureDateWasSelected, setCaptureDateWasSelected] = useState(false);

  const resetCaptureDate = useCallback(() => {
    setCaptureDate(new Date());
    setCaptureDateWasSelected(false);
  }, []);

  useComposerSaved(childId, resetCaptureDate);

  const handleCaptureDateChange = useCallback((nextDate) => {
    if (!(nextDate instanceof Date) || Number.isNaN(nextDate.getTime())) {
      return;
    }

    setCaptureDate(nextDate);
    setCaptureDateWasSelected(true);
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }

    const timer = window.setInterval(() => {
      if (!captureDateWasSelected) {
        setCaptureDate(new Date());
      }
    }, 60000);

    return () => {
      window.clearInterval(timer);
    };
  }, [captureDateWasSelected]);

  return {
    captureDate,
    setCaptureDate,
    setCaptureDateWasSelected,
    handleCaptureDateChange,
    resetCaptureDate,
  };
};

export default useCareCaptureDate;
